import React from 'react';
import { Icon } from './Icon.jsx';

export function LoginScreen({
  variant = 'default',
  onMockLogin,
  mockMode,
  errorEmail,
}) {
  const isError = variant === 'not-provisioned';
  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'var(--sp-bg-page)',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div
        style={{
          position: 'absolute',
          inset: 0,
          pointerEvents: 'none',
          background:
            'radial-gradient(800px 360px at 50% -10%, rgba(5,230,197,0.18), transparent 60%)',
        }}
      />
      <div
        style={{
          height: 64,
          padding: '0 28px',
          display: 'flex',
          alignItems: 'center',
          gap: 10,
        }}
      >
        <img src="/swiftpay/SwiftPay-logo-black.svg" style={{ height: 22 }} />
        <span className="tt-product-tag">ClockIn</span>
      </div>
      <div
        style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '0 24px',
          position: 'relative',
        }}
      >
        <div
          className="card"
          style={{
            width: 420,
            padding: '36px 32px 28px',
            textAlign: 'center',
            borderRadius: 20,
            boxShadow: 'var(--sp-shadow-md)',
          }}
        >
          <div
            style={{
              display: 'inline-flex',
              width: 56,
              height: 56,
              borderRadius: 16,
              background: isError ? '#FFEAD5' : 'var(--sp-mint-100)',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: 20,
              color: isError ? '#C4320A' : '#007C7C',
            }}
          >
            <Icon name={isError ? 'lock' : 'clock'} size={28} stroke={2} />
          </div>
          {isError ? (
            <>
              <h1
                style={{
                  fontSize: 22,
                  fontWeight: 700,
                  margin: '0 0 8px',
                  letterSpacing: '-0.005em',
                }}
              >
                Account not provisioned
              </h1>
              <p
                style={{
                  color: 'var(--sp-fg-2)',
                  fontSize: 14,
                  lineHeight: '22px',
                  margin: '0 0 24px',
                }}
              >
                Your{' '}
                <code
                  style={{
                    background: 'var(--sp-bg-muted)',
                    padding: '1px 6px',
                    borderRadius: 4,
                    fontSize: 13,
                  }}
                >
                  {errorEmail || 'account'}
                </code>{' '}
                was recognised but hasn't been added to ClockIn yet. Ask your
                admin to add you to the employees sheet.
              </p>
              <a
                href="/auth/google"
                className="btn btn-secondary"
                style={{ width: '100%', textDecoration: 'none' }}
              >
                Try a different account
              </a>
              <a
                href="mailto:itadmin@swiftpay.ph"
                className="tt-link"
                style={{
                  display: 'inline-flex',
                  gap: 6,
                  alignItems: 'center',
                  marginTop: 16,
                  fontSize: 13,
                }}
              >
                <Icon name="mail" size={14} /> Email itadmin@swiftpay.ph
              </a>
            </>
          ) : (
            <>
              <h1
                style={{
                  fontSize: 24,
                  fontWeight: 700,
                  margin: '0 0 6px',
                  letterSpacing: '-0.01em',
                }}
              >
                Clock in to ClockIn
              </h1>
              <p
                style={{
                  color: 'var(--sp-fg-2)',
                  fontSize: 14,
                  lineHeight: '22px',
                  margin: '0 0 28px',
                }}
              >
                Log your day in under thirty seconds. Sign in with your{' '}
                <strong>@swiftpay.ph</strong> Google account.
              </p>
              {mockMode ? (
                <button
                  onClick={onMockLogin}
                  style={{
                    width: '100%',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 12,
                    padding: '12px 16px',
                    border: '1px solid var(--sp-border)',
                    borderRadius: 10,
                    background: '#fff',
                    fontSize: 14,
                    fontWeight: 600,
                    color: 'var(--sp-fg-1)',
                    cursor: 'pointer',
                  }}
                >
                  <Icon name="google" size={18} /> Continue (mock)
                </button>
              ) : (
                <a
                  href="/auth/google"
                  style={{
                    width: '100%',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 12,
                    padding: '12px 16px',
                    border: '1px solid var(--sp-border)',
                    borderRadius: 10,
                    background: '#fff',
                    fontSize: 14,
                    fontWeight: 600,
                    color: 'var(--sp-fg-1)',
                    cursor: 'pointer',
                    textDecoration: 'none',
                  }}
                >
                  <Icon name="google" size={18} /> Continue with Google
                </a>
              )}
              <div
                style={{
                  marginTop: 18,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 6,
                  fontSize: 12,
                  color: 'var(--sp-fg-3)',
                }}
              >
                <Icon name="lock" size={12} /> Restricted to @swiftpay.ph
                workspace
                {mockMode && (
                  <span style={{ marginLeft: 6, fontStyle: 'italic' }}>
                    (mock mode)
                  </span>
                )}
              </div>
            </>
          )}
        </div>
      </div>
      <div
        style={{
          padding: '20px 28px 24px',
          textAlign: 'center',
          fontSize: 12,
          color: 'var(--sp-fg-3)',
        }}
      >
        Internal tool · SwiftPay PH · v1.0
      </div>
    </div>
  );
}
